import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { colors } from '@fs/zion-ui'

const draggableStyleDefault = {
  display: 'flex',
  marginTop: '8px',
  backgroundColor: colors.gray00,
  borderRadius: '6px',
  touchAction: 'none',
}

const childrenStyleDefault = {
  flexGrow: 1,
  padding: '10px',
}

export default function SortableItem(props) {
  const { id, children, dragHandle, data } = props
  const { listeners, setNodeRef, transform, transition } = useSortable({ id, data })
  const draggableStyle = data?.draggableStyle || draggableStyleDefault
  const childrenStyle = data?.childrenStyle || childrenStyleDefault

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div ref={setNodeRef} style={style}>
      <div style={draggableStyle}>
        <div style={childrenStyle}>{children}</div>
        <div {...listeners}>{dragHandle}</div>
      </div>
    </div>
  )
}
